/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const AnalysisRemarkStateDto = {
    New: 'NEW',
    Seen: 'SEEN',
    InProgress: 'IN_PROGRESS',
    ToVerify: 'TO_VERIFY',
    Done: 'DONE'
} as const;

export type AnalysisRemarkStateDto = typeof AnalysisRemarkStateDto[keyof typeof AnalysisRemarkStateDto];



